<div class="container">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Record Saved Successfully!</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="bottom-20"><strong>Online Enrollment Confirmation # {{confirmationNumber}}</strong></p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="callStep3()">Click here to complete this enrollment</button>
            <button class="button primary" (click)="enrollNew()">Enroll New Client</button>
        </div>
    </div>
</div>